export default __webpack_public_path__ + "static/media/emoji.02a814e2.svg";